import ProjectInfo from '../../components/projectInfo';
import { hexToRgb } from '../../utils/utils';

function onRemovePano() {
  if (this.hotspotMusic) {
    this.hotspotMusic.pause();
  }
}
function onPanoStart(data) {
  console.log(data);
}

function onNewScene(data) {
  if (data) {
    const { musicBg, musicExplain, rolltxt } = data;
    //设置场景音乐
    this.setSceneMusic(musicBg, musicExplain);
    if (rolltxt) {
      //设置场景字幕
      const bgRgb = hexToRgb(rolltxt.bgcolor);
      const textColor = rolltxt.css.color;
      this.setSceneTextScroll({
        content: rolltxt.text,
        wrapperStyle: {
          height: `${rolltxt.height}px`,
          backgroundColor: `rgba(${bgRgb.r},${bgRgb.g},${bgRgb.b},${rolltxt.bgalpha})`,
        },
        textStyle: {
          ...rolltxt.css,
          color: `rgba(${textColor.r},${textColor.g},${textColor.b},${textColor.a})`,
        },
        speed: rolltxt.speed,
        duration: rolltxt.interval_time,
      });
    }else{
      if (this.scenescrollText) this.scenescrollText.remove();
    }
  } else {
    if (this.scenescrollText) this.scenescrollText.remove();
    this.hotspotMusicPause();
    this.bgMusicPause();
    this.explainMusicPause();
    this.setSceneMusic(null, null);
  }
}

function onLoadError() {
  console.log('handleLoadError');
}

function showProjectInfo() {
  const { configPanoInfo } = this.params;
  if (!configPanoInfo) return;
  new ProjectInfo({
    wrapper: this.$container.get(0),
    text: configPanoInfo.title,
    isSelect: configPanoInfo.isSelect,
    auther: configPanoInfo.auther,
    view: configPanoInfo.view,
  });
}

function onSceneCruiseEnd(data) {
  if (!data) return;
  const { next_scene_name } = data;
  if (next_scene_name) {
    this.changeSceneByName(next_scene_name);
    this.updateSceneListByName(next_scene_name);
  }
}

function changeSceneByName(name) {
  //设置url  scene的值

  if (window.history){ 
    // 支持History API 
    window.history.replaceState(null, null, '?scene_id=' + name.split("_")[1])
  } else { 
    // 不支持History API 
  }

  if (!this.krpano) return;
  const configScenes = this.configScenes;
  var arr = {
    1: 'NOBLEND',
    2: 'BLEND(1.0, easeInCubic)',
    3: 'ZOOMBLEND(2.0, 2.0, easeInOutSine)',
    4: 'COLORBLEND(2.0, 0x000000, easeOutSine)',
    5: 'LIGHTBLEND(1.0, 0xFFFFFF, 2.0, linear)',
    6: 'SLIDEBLEND(1.0, 135.0, 0.4, linear)',
    7: 'OPENBLEND(1.0, 0.0, 0.2, 0.0, linear)',
  };
  this.krpano.get('global').actions.loadscene(name, null, (configScenes.animation && configScenes.animation.keepView && configScenes.animation.keepView == 1) ? 'KEEPVIEW|KEEPMOVING|NOPREVIEW' : null, arr[configScenes.animation.type]);
}

function getFirstPano(data) {
  let item;
  function tree(data) {
    for (let index = 0; index < data.length; index++) {
      if (item) break;
      const el = data[index];
      if (el.children) {
        tree(el.children);
      } else {
        item = el.scenes[0];
        if (item) break;
      }
    }
  }
  tree(data, name);
  return item;
}

function changeSceneView(data){
  if (data.fov) {
    this.krpano.set('view.hlookat',data.hlookat);
    this.krpano.set('view.vlookat',data.vlookat);
    this.krpano.set('view.fov',data.fov);
  }
}

export default {
  onRemovePano,
  onNewScene,
  onLoadError,
  showProjectInfo,
  changeSceneByName,
  onSceneCruiseEnd,
  onPanoStart,
  changeSceneView
};
